import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import Gatter from "../DetailGatter/Gatter";
import Line from "../DetailGatter/Line";
import Text from "../DetailGatter/Text";

export default function NeutralTester() {
  const [inputA, setInputA] = useState(0);
  const [inputB, setInputB] = useState(0);
  const [carryIn, setCarryIn] = useState(0);

  // ✅ FIX: correct useState (you missed testResult variable)
  const [testResult, setTestResult] = useState(false);

  const [testXor1, setTestXor1] = useState(0);
  const [testXor2, setTestXor2] = useState(0);
  const [testAnd1, setTestAnd1] = useState(0);
  const [testAnd2, setTestAnd2] = useState(0);
  const [testOr, setTestOr] = useState(0);

  // ✅ logic
  const sum1 = inputA ^ inputB;
  const carry1 = inputA & inputB;
  const sumOut = sum1 ^ carryIn;
  const carry2 = sum1 & carryIn;
  const carryOut = carry1 || carry2;

  useEffect(() => {
    const checker =
      sum1 === testXor1 &&
      carry1 === testAnd1 &&
      sumOut === testXor2 &&
      carry2 === testAnd2 &&
      carryOut === testOr;

    setTestResult(checker);
  }, [
    inputA,
    inputB,
    carryIn,
    testXor1,
    testXor2,
    testAnd1,
    testAnd2,
    testOr,
    sum1,
    carry1,
    sumOut,
    carry2,
    carryOut,
  ]);

  const toggle = (value, setter) => setter(value ? 0 : 1);

  return (
    <Box
      sx={{
        mt: 2,
        width: "95%",
        maxWidth: 700,
        mx: "auto",
      }}
    >
      <svg
        viewBox="0 0 700 220"
        height="100%"
        style={{
          background: "white",
          border: "1px solid #000",
        }}
      >
        {/* Inputs */}
        <Text x={20} y={30} text="Ü" />
        <Line
          x1={60}
          x2={360}
          y={24}
          position="start"
          handleClick={() => toggle(carryIn, setCarryIn)}
        />

        <Text x={20} y={70} text="A" />
        <Line
          x1={60}
          x2={200}
          y={63}
          position="start"
          handleClick={() => toggle(inputA, setInputA)}
        />

        <Text x={20} y={100} text="B" />
        <Line
          x1={60}
          x2={200}
          y={92}
          position="start"
          handleClick={() => toggle(inputB, setInputB)}
        />

        {/* Gates */}
        <Gatter x={200} y={45} text="XOR" />
        <Gatter x={360} y={10} text="XOR" />
        <Gatter x={200} y={140} text="AND" />
        <Gatter x={360} y={90} text="AND" />
        <Gatter x={500} y={110} text="OR" />

        {/* Connections */}
        <Line x1={170} x2={200} y={63} y2={165} position="angle" />
        <Line x1={150} x2={200} y={92} y2={185} position="angle" />

        <Line x1={340} x2={360} y={25} y2={110} position="angle" />
        <Line x1={320} x2={360} y={60} y2={130} position="angle" />

        <Line
          x1={300}
          x2={360}
          y={60}
          position="start"
          handleClick={() => toggle(testXor1, setTestXor1)}
        />

        <Line
          x1={460}
          x2={640}
          y={40}
          position="both"
          handleClick={() => toggle(testXor2, setTestXor2)}
        />
        <Text x={665} y={47} text="X" />

        <Line
          x1={300}
          x2={500}
          y={160}
          position="start"
          handleClick={() => toggle(testAnd1, setTestAnd1)}
        />

        <Line
          x1={460}
          x2={500}
          y={130}
          position="start"
          handleClick={() => toggle(testAnd2, setTestAnd2)}
        />

        <Line
          x1={600}
          x2={640}
          y={130}
          position="both"
          handleClick={() => toggle(testOr, setTestOr)}
        />
        <Text x={665} y={135} text="Ü" />
      </svg>

      {/* ✅ Optional debug output */}
      <div style={{ marginTop: 10 }}>
        Test result: {testResult ? "✅ correct" : "❌ incorrect"}
      </div>
    </Box>
  );
}
